// C.1 — Био-инженер Клод (livlife_klod).
//
// xlsx v6 dsl_trigger1:
//   event: turn_start, target: enemy_random, effect: infect, value: 1
//   → В начале каждого своего хода: 1 стак Заражён случайному
//     вражескому юниту.
//
// xlsx v6 dsl_active (Ф2, 1× за матч):
//   target: enemy_infected_aoe
//   effect: composite, value: damage:3@enemy_infected_aoe | remove_keyword:infected@enemy_infected_aoe
//   → Нанести 3 урона ВСЕМ заражённым вражеским юнитам и снять с них
//     Заражение.

import { registerImplementedAbility } from '../../warn-unimplemented.js';
import { addInfectedStack, removeInfectedFromAll, clearInfected } from '../../../keywords/infected.js';
import { applyDamage } from '../../../combat.js';
import { resolveTarget } from '../../../effects/targets.js';

export const HERO_ID = 'livlife_klod';

// Trigger в начале хода игрока за Клода.
export function klodOnTurnStart(state, playerIdx) {
  const p = state.players?.[playerIdx];
  if (!p?.hero || p.hero.id !== HERO_ID) return;
  if (p.hero.current?.silenced) return;
  // 1 стак случайному вражескому юниту.
  const targets = resolveTarget(state, p.hero, 'enemy_random');
  if (targets.length === 0) return;
  for (const t of targets) {
    if (t.type !== 'unit') continue;
    addInfectedStack(state, t, HERO_ID, 1);
  }
}

// Активка Ф2.
export function klodActive(state, playerIdx) {
  const p = state.players?.[playerIdx];
  if (!p?.hero || p.hero.id !== HERO_ID) return { ok: false, reason: 'wrong_hero' };
  if (p.heroActiveUsedThisMatch) return { ok: false, reason: 'already_used' };

  const enemyIdx = 1 - playerIdx;
  const enemy = state.players?.[enemyIdx];
  if (!enemy?.field) return { ok: false, reason: 'no_enemy' };

  const infected = [];
  for (const row of enemy.field) {
    if (!row) continue;
    for (const u of row) {
      if (!u || !u.isAlive || !u.isAlive()) continue;
      if ((u.infectedStacks || 0) <= 0) continue;
      infected.push(u);
    }
  }

  if (infected.length === 0) {
    return { ok: false, reason: 'no_infected_targets' };
  }

  // 3 урона каждому заражённому.
  for (const t of infected) {
    applyDamage(t, 3, {
      state,
      source: { id: HERO_ID, name_ru: 'Био-инженер Клод' }
    });
  }
  // Снять Заражение со всех вражеских юнитов.
  removeInfectedFromAll(state, enemyIdx);
  // Защитная ветка — если кто-то остался с стаком.
  for (const t of infected) {
    if (t.infectedStacks > 0) clearInfected(state, t);
  }

  p.heroActiveUsedThisMatch = true;
  if (state.log) {
    state.log.add(`💉 Клод [${p.name}]: активка — 3 урона ${infected.length} заражённым целям`);
  }
  return { ok: true };
}

export function klodActiveAvailable(state, playerIdx) {
  const p = state.players?.[playerIdx];
  if (!p?.hero || p.hero.id !== HERO_ID) return false;
  if (p.heroActiveUsedThisMatch) return false;
  if (p.hero.current?.silenced) return false;
  // Хотя бы один заражённый враг.
  const enemyIdx = 1 - playerIdx;
  const enemy = state.players?.[enemyIdx];
  if (!enemy?.field) return false;
  for (const row of enemy.field) {
    if (!row) continue;
    for (const u of row) {
      if (u && (u.infectedStacks || 0) > 0) return true;
    }
  }
  return false;
}

registerImplementedAbility(HERO_ID, 'trigger', 'active');
